'use client';

import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '../../utils/cn/cn';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverArrow = PopoverPrimitive.Arrow;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    containerRef?: React.RefObject<HTMLElement | null>;
    variant?: 'default' | 'tipp';
  }
>(({ className, align = 'center', sideOffset = 0, variant = 'default', ...props }, ref) => {
  const sharedProps = {
    ref,
    align,
    sideOffset,
    side: 'bottom' as const,
    className: cn(
      'bg-color-background-base z-50 rounded-sm p-2 shadow-sm outline-hidden',
      className,
    ),
    ...props,
  };

  // Arrow is incompatible with asChild: Slot (used internally by asChild) calls
  // React.Children.only and fails when there are multiple children (content + Arrow).
  if (variant === 'tipp' && !props.asChild) {
    return (
      // No Portal because in Modals it appears in the background
      <PopoverPrimitive.Content {...sharedProps}>
        {props.children}
        <PopoverPrimitive.Arrow className="fill-color-background-base size-1.5 drop-shadow-sm" />
      </PopoverPrimitive.Content>
    );
  }

  return (
    <PopoverPrimitive.Portal container={props.containerRef?.current}>
      <PopoverPrimitive.Content {...sharedProps} />
    </PopoverPrimitive.Portal>
  );
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverArrow };
